import { render, staticRenderFns } from "./RxAlert.vue?vue&type=template&id=096efe20"
import script from "./RxAlert.vue?vue&type=script&lang=js"
export * from "./RxAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports